<template>
  <div>
    <b-card class="mt-2">
      <b-row>
        <b-col md="6">
          <label>
            Nombre: <b>  {{ nombres }} </b>
          </label>
        </b-col>
        <b-col md="6">
          <label>
            Apellidos: <b>  {{ apellidos }} </b>
          </label>
        </b-col>
        <b-col class ="mt-1" md="6">
          <label>
            Identificacion: <b>  {{ identificacion }} </b>
          </label>
        </b-col>
        <b-col class ="mt-1" md="6">
          <label>
            Correo: <b>  {{ user_email }} </b>
          </label>
        </b-col>
      </b-row>
    </b-card>
    <b-card-code class="principal">
      <validation-observer ref="usuarioValidation">
        <b-form @submit.prevent>
          <b-row class="mt-1 mb-1">
            <b-col md="6">
              <validation-provider #default="{ errors }" name="Estado" rules="required">
              <b-form-group label-for="Establecimiento" :state="errors.length > 0 ? false : null">
                
                <label>Establecimiento <span class="text-danger">*</span></label>
                <v-select id="establecimiento" v-model="establecimiento" label="text" :options="opsEstabSalud"
                :state="errors.length > 0 ? false : null" >
                 
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            </b-col>
        
            <b-col md="6">
              <validation-provider #default="{ errors }" name="Estado" rules="required">
                <b-form-group label-for="Estado" :state="errors.length > 0 ? false : null">
                  <label>Estado: <span class="text-danger">*</span></label>
                  <v-select id="activo" v-model="selectedEstado" :options="estado" :reduce="(option) => option.value"
                    label="text" :state="errors.length > 0 ? false : null" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="mc-username">
                <label>Username: <span class="text-danger">*</span></label>
                <validation-provider #default="{ errors }" name="Username" rules="required">
                  <b-form-input id="mc-username" v-model="username" placeholder="Username"
                    :state="errors.length > 0 ? false : null" name="username" disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- <b-col md="6">
              <b-form-group
                label-for="mc-nombres"
              >
                <label>Nombres: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Nombres"
                  rules="required"
                >
                  <b-form-input
                    id="mc-nombres"
                    v-model="nombres"
                    placeholder="Nombres"
                    name="nombres"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-for="mc-apellidos"
              >
                <label>Apellidos: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Apellidos"
                  rules="required"
                >
                  <b-form-input
                    id="mc-apellidos"
                    v-model="apellidos"
                    placeholder="Apellido"
                    name="apellidos"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="6">
              <b-form-group
                label-for="mc-email"
              >
                <label>Correo eletrónico: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Correo eletrónico"
                  rules="required|email"
                >
                  <b-form-input
                    id="mc-email"
                    v-model="user_email"
                    placeholder="ana@example.com"
                    name="email"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-for="mc-identificacion"
              >
                <label>Identificación: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Identificación"
                  rules="required|integer|digits:10"
                >
                  <b-form-input
                    id="mc-identificacion"
                    v-model="identificacion"
                    placeholder="0999999999"
                    name="identificacion"
                    type="text"
                    maxlength="10"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <b-col md="6">
              <b-form-group label-for="mc-password">
                <label>Contraseña: <span class="text-danger">*</span></label>
                <b-input-group label="Contraseña">
                  <b-form-input id="user-password" v-model="password" :type="passwordFieldType" name="new-password" autocomplete="new-password"
                    placeholder="············" />
                  <b-input-group-append is-text>
                    <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility" />
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="Roles">
                <label>Roles: </label>
                <v-select id="roles" v-model="selectedRoles" multiple :options="roles"
                  :reduce="(option) => option.token" label="nombre" />
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col md="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" type="submit" variant="primary"
                class="mr-1 btn-guardar" @click="validationForm">
                <feather-icon icon="SaveIcon" size="16" class="align-text-top" />
                <span>&nbsp;Guardar</span>
              </b-button>
              <!--              <b-button-->
              <!--                v-ripple.400="'rgba(186, 191, 199, 0.15)'"-->
              <!--                size="sm"-->
              <!--                type="reset"-->
              <!--                variant="outline-secondary"-->
              <!--              >-->
              <!--                Reset-->
              <!--              </b-button>-->
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-code>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import BCardCode from '@core/components/b-card-code'
import {
  required, email, integer, digits,
} from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import es from 'vee-validate/dist/locale/es.json'
import actions from '@/assets/utils/utils'
import $ from 'jquery'

import rutas from '@/assets/utils/rutas.json';
import Vue from "vue";

localize({
  es,
})

localize('es')

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BInputGroupAppend,
    BInputGroup,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    vSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      opsEstabSalud:[],
      establecimiento: null,
      login_user: '',
      selectedPersona: null,
      search: '',
      personas: [],
      username: '',
      nombres: '',
      apellidos: '',
      identificacion: '',
      user_email: '',
      password: '',
      token: '',
      loading: null,
      selectedRoles: [],
      roles: [],
      idPersona: null,
      activo: true,
      required,
      email,
      integer,
      digits,

      selectedEstado: 'Activo',
      estado: [
        { value: 'Activo', text: 'Activo' },
        { value: 'Inactivo', text: 'Inactivo' },
      ],
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  mounted() {
    this.fetchEstablecimientos()
    this.getRoles()
    if (this.$route.params.token) {
      this.token = this.$route.params.token
      this.getUser()
    } else {
      actions.setearTitulo('')
    }
  },
  created() {
    
    $('#btn-excel').remove()
    $('#btn-pdf').remove()
    $('#eliminar-viajes').remove()
    this.setToken()
  },
  methods: {
    async fetchEstablecimientos() {
            const query = `
                query {
                    allEstablecimientos {
                        id
                        Descripcion
                        uniCodigo
                    }
                }
            `;
            try {
                const response = await axios.post(rutas.axios + 'api', { query });
                this.opsEstabSalud = response.data.data.allEstablecimientos.map(item => ({
                    value: item.id,
                    text: item.Descripcion,
                    uniCodigo: item.uniCodigo
                }));
            } catch (error) {
                console.error('An error occurred while fetching the options:', error);
            }
        },

    onSearch(searchQuery) {
      this.search = searchQuery;
      this.loading = true;
      if (this.search.length > 2) {


        this.fetchPersonas();
        this.loading = false;
      }

    },

    fetchPersonas() {
      axios.post('api', {
        query: `query MyQuery($search : String) {
  allPersona(search: $search) {
    correo
    identificacion
    primerApellido
    primerNombre
    id
  }
}`,
        variables: {
          search: this.search,
        },
      }).then(response => {
        if (response.status === 200) {

          this.personas = response.data.data.allPersona.map(item => ({
            value: item.id,
            text: item.primerNombre + " " + item.primerApellido + " (" + item.identificacion + ")"

          }));
          console.log(this.personas)
        } else {
          console.log("error en la busqueda de persona")

        }
      })
    },
    comprobarPermisos() {
      if (localStorage.getItem('permisos').indexOf('usu_usuario_registrar') === -1) {
        this.$router.push({ name: 'not-permitted' })
      }
    },
    getUser() {
      axios.post('api', {
        query: `query userByToken($token: String!) {
  userByToken(tokenUser: $token) {
    usuario {
      token
      avatar
      establecimiento {
      id
      Descripcion
      }
      usuario {
        username
        
        first_name: firstName
        last_name: lastName
        email
        is_active: isActive
      }
      persona {
        id
        primerNombre
        primerApellido
        identificacion
        correo
      }
    
    }
    listaRoles {
      token
      nombre
    }
    status
    message
  }
}`,
        variables: {
          token: this.$route.params.token,
        },
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.userByToken.status === 'success') {
            
            const datos = response.data.data.userByToken.usuario

            console.log("estos son los datos del usuario", datos)
            this.establecimiento = {
              value : datos.establecimiento? datos.establecimiento.id : null,
              text : datos.establecimiento ? datos.establecimiento.Descripcion : null
            } 
            this.username = datos.usuario.username
            
            this.idPersona = datos.persona.id
            this.nombres = datos.persona.primerNombre ? `${datos.persona.primerNombre}` : "No disponible"
            this.apellidos = datos.persona.primerApellido ? `${datos.persona.primerApellido}` : "No disponible"
            this.identificacion = datos.persona.identificacion ? `${datos.persona.identificacion}` : "No disponible"
            this.user_email =  datos.persona.correo ? `${datos.persona.correo}` : "No disponible"
            if (datos.usuario.is_active === true) {
              this.selectedEstado = 'Activo'
            } else {
              this.selectedEstado = 'Inactivo'
            }
            this.activo = datos.usuario.is_active
            this.selectedRoles = response.data.data.userByToken.listaRoles
            actions.setearTitulo('Editar Usuario')
          } else {
            this.$router.push({ name: 'error-404' })
          }
        }
      })
    },
    validationForm() {
      this.$refs.usuarioValidation.validate().then(success => {
        if (success) {
          this.saveUsuario()
        }
      })
    },
    saveUsuario() {
      if(!this.establecimiento || !this.establecimiento.value) {
        this.$swal.fire({
          icon : "error",
          text : "Escoja un establecimiento"
        })
        return
      }
      
      actions.bloquearBoton()

      this.activo = this.selectedEstado === 'Activo'
      axios.post('api', {
        query: `mutation EditUser($username: String!, $password: String, $persona: ID, $isActive: Boolean!, $token: String!, $establecimiento : ID!){
                    editUser(username:$username, password: $password, persona: $persona, isActive: $isActive, tokenUser: $token, establecimiento : $establecimiento)
                    {
                        user{
                            token,
                        }
                        status,
                        message,
                    }
                }`,
        variables: {
          username: this.username,
          //email: this.user_email,
          password: this.password,
          //identificacion: this.identificacion,
          //nombres: this.nombres,
          //apellidos: this.apellidos,
          establecimiento : this.establecimiento.value,
          persona: this.idPersona,
          isActive: this.activo,
          token: this.token,
        },
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.editUser.status === 'success') {
            const { token } = response.data.data.editUser.user
            this.token = token
            this.asignarRoles()
            this.showToast()
            if (this.$route.params.token) {
              this.$router.push({name: 'usuario'})
            } else {
              this.$router.push({ name: 'editusuario', params: { token } })
            }
          } else {
            this.$swal({
              title: 'Error',
              text: response.data.data.editUser.message,
              icon: 'error',
              confirmButtonColor: '#089599',
            })
          }
        }
        actions.desbloquearBoton()
      })
    },

    getRoles() {
      axios.post('api', {
        query: `{
                    getRoles{
                        roles{
                            token,
                            nombre
                        },
                        status,
                        message
                    }
                }`,
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.getRoles.status === 'success') {
            this.roles = response.data.data.getRoles.roles
          }
        }
      })
    },
    asignarRoles() {
      axios.post('api', {
        query: `query asignarRoles($tokenUsuario:String!, $rolesNuevos:[String]){
            asignarRoles(tokenUsuario:$tokenUsuario, rolesNuevos:$rolesNuevos){
                status,
                message
            }
        }`,
        variables: {
          tokenUsuario: this.token,
          rolesNuevos: this.selectedRoles,
        },
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.asignarRoles.status === 'success') {
            console.log(response.data.data.asignarRoles.message)
          }
        }
      })
    },
    showToast() {
      this.$toast.success({
        component: ToastificationContent,
        props: {
          title: 'Usuario',
          icon: 'InfoIcon',
          text: `Se ha actualizado con éxito el usuario ${this.username}`,
        },
      },
        {
          position: 'bottom-right',
        })
    },
    setToken() {
      const usuarioCookie = this.$cookie.get('usuario')
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie)
        this.login_user = user.username
        axios.defaults.headers.common.Authorization = `JWT ${user.token}` // for all requests
      }
    },
  },
}
</script>
<style>
.principal .card-header {
  display: none !important
}

.principal .card-body {
  padding-bottom: 0 !important;
}
</style>
